export const WEB_PROTOCOL = {
  HTTP: "HTTP",
  HTTPS: "HTTPS",
  SOCKS4: "SOCKS4",
  SOCKS4H: "SOCKS4H",
  SOCKS5: "SOCKS5",
  SOCKS5H: "SOCKS5H",
}
